import { ArrowForwardIos } from '@mui/icons-material'
import { Box, Stack, Typography, useTheme } from '@mui/material'
import { DateTime } from 'luxon'
import { CalendarTimeRange } from '../types/models'
import { lang } from '../utils/lang'

export interface IntervalPanelProps {
  interval: CalendarTimeRange
  text: string
  error?: boolean
  onSelect: () => void
}

/**
 * Summarize linked interval numbers.
 */
export function IntervalPanel(props: IntervalPanelProps): React.ReactElement {

  const { interval, text, onSelect, error } = props
  const theme = useTheme()

  const CircleOn = <Box component="span" sx={{ display: 'inline-block', height: '0.5rem', width: '0.5rem', backgroundColor: 'primary.main', borderRadius: '0.25rem' }}></Box>
  const CircleOff = <Box component="span" sx={{ display: 'inline-block', height: '0.5rem', width: '0.5rem', backgroundColor: theme.palette.grey[600], borderRadius: '0.25rem' }}></Box>

  return (
    <Box sx={{
      backgroundColor: theme.palette.grey[900],
      boxShadow: theme.boxShadow.main,
      borderRadius: '1.25rem',
    }}>
      <Box sx={{
        display: 'grid',
        gridTemplateColumns: 'auto 6rem 2rem',
        alignItems: 'center',
        paddingLeft: '1rem',
        height: '4rem',
      }}>
        <Stack>
          <Box data-cy="box-Interval Time">
            <Typography data-cy="text-Interval Time" sx={{ color: error ? 'error.light' : theme.palette.grey[100] }}>
              {lang.time(DateTime.fromISO(`2000-01-01T${interval.start}:00`))}
              &nbsp;–&nbsp;
              {lang.time(DateTime.fromISO(`2000-01-01T${interval.stop}:00`))}
            </Typography>
          </Box>
          <Stack direction="row" spacing={0.5} sx={{ mt: 0.5 }}>
            {interval.weekdays[0] ? CircleOn : CircleOff}
            {interval.weekdays[1] ? CircleOn : CircleOff}
            {interval.weekdays[2] ? CircleOn : CircleOff}
            {interval.weekdays[3] ? CircleOn : CircleOff}
            {interval.weekdays[4] ? CircleOn : CircleOff}
            {interval.weekdays[5] ? CircleOn : CircleOff}
            {interval.weekdays[6] ? CircleOn : CircleOff}
          </Stack>
        </Stack>
        <Box sx={{ color: 'primary.main' }}>{text}</Box>
        <ArrowForwardIos sx={{ cursor: 'pointer' }} onClick={onSelect}/>
    </Box>
  </Box>
  )
}
